/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable prettier/prettier */
/* eslint-disable no-unused-vars */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import { useInfiniteQuery } from '@tanstack/react-query';
import {
  flexRender,
  getCoreRowModel,
  getFilteredRowModel,
  useReactTable,
  ColumnDef,
  SortingState,
} from '@tanstack/react-table';
import prepareQueryParam from '@Utils/prepareQueryParam';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@Components/RadixComponents/Table';
import Icon from '@Components/common/Icon';
import useIntersectionObserver from '@Hooks/useIntersectionObserver';
import Skeleton from '@Components/RadixComponents/Skeleton';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import {
  excludeSortColumnNames,
  excludeVerticalTopPathNames,
  // alignedEndHedaerkeys,
} from '@Constants/index';
import isEmpty from '@Utils/isEmpty';
import { getDisplayedRowCount } from '@Utils/index';
import useSortingConfig from '@Hooks/useSortingConfig';
import { FlexColumn, FlexRow } from '../Layouts';
import TableSkeleton from './TableSkeleton';

interface ColumnData {
  [x: string]: any;
  component_budget: any;
  component_name: any;
  component_id: any;
  component?: any;
  header: string;
  accessorKey: string;
  cell?: any;
}

interface DataTableProps {
  columns: ColumnDef<ColumnData>[];
  queryKey: string;
  queryFn: (params: any) => Promise<any> | void;
  queryFnParams?: Record<string, any> | any;
  initialState?: any;
  searchInput: string;
  className?: string;
  demoData?: any;
  onRowClick?: any;
  isPaginated?: boolean;
  needSorting?: boolean;
  needRowLinkIcon?: boolean;
  cellClassName?: string;
  tableStyle?: any;
  showDataCount?: boolean;
  dataCountCategory?: string;
  exportMode?: boolean;
  sortByKey?: boolean;
}

export default function DataTable({
  columns,
  queryKey,
  queryFn,
  initialState,
  searchInput,
  queryFnParams, // data,
  className,
  demoData,
  onRowClick,
  isPaginated = true,
  needSorting = true, // sorting, by defalut sorting is available, if not needed pass false
  needRowLinkIcon = false, // if row link icon is needed pass true
  cellClassName,
  tableStyle,
  showDataCount = false,
  dataCountCategory,
  exportMode = false,
  // sort table in ascending/descending order by actual column accessorKey rather than asc/desc value
  sortByKey = false,
}: DataTableProps) {
  const [sorting, setSorting] = useState<SortingState>([]);
  const defaultData = React.useMemo(() => [], []);
  const [isIntersecting, _, viewRef] = useIntersectionObserver();
  const { pathname } = useLocation();

  const { sortOrderKey, sortDir, sortBy } = useSortingConfig(
    sorting[0]?.id,
    sorting[0]?.desc,
    sortByKey,
  );

  const { data, isLoading, fetchNextPage, isError, error, hasNextPage } =
    useInfiniteQuery({
      queryKey: [queryKey, searchInput, queryFnParams, sortOrderKey, sortDir],
      queryFn: async ({ pageParam = 1 }) => {
        const res = await queryFn({
          page: pageParam,
          search: searchInput,
          sort_by: sortBy,
          [sortOrderKey]: sortDir,
          page_size: 15,
          ...(queryFnParams ? prepareQueryParam(queryFnParams) : {}),
        });
        return res?.data;
      },
      getNextPageParam: lastPage => {
        return lastPage?.next_page ?? undefined;
      },
    });

  const table = useReactTable({
    data: data
      ? isPaginated
        ? data?.pages?.reduce(
            (acc: Record<string, any>[], page: Record<string, any>) => {
              return [...acc, ...(page.results || page)];
            },
            [],
          )
        : (data?.pages[0] ?? demoData ?? defaultData)
      : [],
    columns,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    state: {
      sorting,
      // globalFilter: searchInput,
    },
    onSortingChange: setSorting,
    manualSorting: true,
    manualPagination: true,
    debugTable: true,
  });

  useEffect(() => {
    if (isIntersecting && hasNextPage) {
      fetchNextPage();
    }
  }, [isIntersecting, fetchNextPage, hasNextPage]);

  if (isError) {
    // @ts-ignore
    const caughtError = error?.response?.data?.detail;
    toast.error(caughtError || (error as Error).message);
  }
  if (isLoading) {
    return <TableSkeleton />;
  }

  return (
    <FlexColumn className="naxatw-h-full naxatw-gap-2">
      {data?.pages && showDataCount && (
        <div className="data-count naxatw-mb-1 naxatw-flex naxatw-items-center naxatw-gap-1 naxatw-px-4 naxatw-font-semibold naxatw-text-[#0B2E62]">
          <p className="">{getDisplayedRowCount(data?.pages)}</p>
          <span>of</span>
          <p>{data?.pages?.[0]?.count || 0}</p>
          <p className="naxatw-capitalize">{dataCountCategory}</p>
        </div>
      )}

      <Table className={`naxatw-w-full ${className}`} style={tableStyle}>
        <TableHeader className="thead !naxatw-h-[3rem]">
          {table.getHeaderGroups().map(headerGroup => (
            <TableRow key={headerGroup.id} className="table-head-row-tr">
              {headerGroup.headers.map(header => {
                const isNotSortable =
                  excludeSortColumnNames?.includes(
                    /*  @ts-ignore  */
                    header?.column?.columnDef?.accessorKey,
                  ) || header.column.columnDef.header === '';
                return (
                  <TableHead
                    key={header.id}
                    onClick={
                      isNotSortable
                        ? () => {}
                        : header.column.getToggleSortingHandler()
                    }
                    className="table-head-th !naxatw-bg-grey-100"
                    style={{
                      width: `${header?.getSize()}px`,
                    }}
                  >
                    {!header.isPlaceholder && (
                      <FlexRow
                        className={`naxatw-group naxatw-cursor-pointer naxatw-items-center naxatw-justify-start naxatw-gap-1 naxatw-px-3 naxatw-py-0  hover:naxatw-text-secondary-500 xl:naxatw-px-6  ${
                          header.column.getIsSorted() !== false
                            ? 'naxatw-text-secondary-500'
                            : 'naxatw-text-matt-100'
                        } ${exportMode ? '!naxatw-text-xs' : ''}`}
                      >
                        {flexRender(
                          header.column.columnDef.header,
                          header.getContext(),
                        )}
                        {excludeSortColumnNames?.includes(
                          /*  @ts-ignore  */
                          header?.column?.columnDef?.accessorKey,
                        ) || header.column.columnDef.header === '' ? null : (
                          <div
                            className={`naxatw-flex naxatw-flex-col naxatw-items-center naxatw-justify-center naxatw-gap-1 ${header.id === 'pdfIcon' ? 'naxatw-hidden' : 'naxatw-block'} ${needSorting ? 'naxatw-block' : 'naxatw-hidden'}`}
                          >
                            {(header.column.getIsSorted() === 'asc' ||
                              header.column.getIsSorted() === false) && (
                              <Icon
                                name="expand_less"
                                className={`!naxatw-flex !naxatw-h-[6px] !naxatw-items-center !naxatw-justify-start !naxatw-text-base group-hover:naxatw-text-secondary-500 ${
                                  header.column.getIsSorted() !== false
                                    ? 'naxatw-text-secondary-500'
                                    : 'naxatw-text-matt-100'
                                }`}
                              />
                            )}
                            {(header.column.getIsSorted() === 'desc' ||
                              header.column.getIsSorted() === false) && (
                              <Icon
                                name="expand_more"
                                className={`!naxatw-text-icon-sm !naxatw-flex !naxatw-h-[6px] !naxatw-items-center !naxatw-justify-start !naxatw-text-base group-hover:naxatw-text-secondary-500 ${
                                  header.column.getIsSorted() !== false
                                    ? 'naxatw-text-secondary-500'
                                    : 'naxatw-text-matt-100'
                                }`}
                              />
                            )}
                          </div>
                        )}
                      </FlexRow>
                    )}
                  </TableHead>
                );
              })}
            </TableRow>
          ))}
        </TableHeader>

        <TableBody>
          {table.getRowModel()?.rows?.length ? (
            table.getRowModel()?.rows.map(row => (
              <TableRow
                key={row.id}
                data-state={row.getIsSelected() && 'selected'}
                onClick={() => onRowClick(row) || null}
                className="table-body-row naxatw-w-full naxatw-cursor-pointer"
              >
                {row.getVisibleCells().map(cell => {
                  return (
                    <TableCell
                      key={cell.id}
                      className={`${cellClassName} ${cell.column.id === 'S.N' ? '!naxatw-w-[5%]' : ''} table-body-row-child ${excludeVerticalTopPathNames?.some(path => pathname.includes(path)) ? '' : 'naxatw-align-top'}`}
                      // @ts-ignore
                      columnId={cell.column.id}
                      style={{
                        width: `${cell.column.getSize()}px`,
                      }}
                    >
                      {cell.getValue() !== null ? (
                        Array.isArray(cell.getValue()) ? (
                          (cell.getValue() as any[]).length > 0 ? (
                            <ul className="naxatw-flex naxatw-flex-col naxatw-items-start naxatw-justify-start naxatw-gap-2">
                              {(cell.getValue() as any[]).map(
                                (item: any, index: number) => (
                                  <li
                                    key={index}
                                    className={`naxatw-flex naxatw-items-center naxatw-gap-1
                                      naxatw-leading-[1.2rem] ${
                                        // @ts-ignore
                                        cell.column.columnDef.accessorKey ===
                                        'sector'
                                          ? 'text-wrap-ellipsis'
                                          : ''
                                      }`}
                                  >
                                    <p>-</p>
                                    <p className="text-wrap-ellipsis">{item}</p>
                                  </li>
                                ),
                              )}
                            </ul>
                          ) : (
                            <div className="!naxatw-min-w-[8rem] naxatw-text-center naxatw-font-bold">
                              <div className="naxatw-mx-auto naxatw-h-[1px] naxatw-w-[0.625rem] naxatw-bg-black" />
                            </div>
                          )
                        ) : (
                          <div
                            className={`naxatw-flex  naxatw-bg-center naxatw-leading-normal ${cell.column.id === 'icon' || cell.column.id === 'icons' ? 'naxatw-justify-end' : 'naxatw-justify-center'}`}
                          >
                            {flexRender(
                              cell.column.columnDef.cell,
                              cell.getContext(),
                            )}
                          </div>
                        )
                      ) : (
                        '-'
                      )}
                    </TableCell>
                  );
                })}
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell
                colSpan={columns.length}
                className="naxatw-text-center"
              >
                No Data found.
              </TableCell>
            </TableRow>
          )}
          {isPaginated &&
            hasNextPage &&
            Array.from({ length: 3 }).map((__, rowindex: number) => (
              <TableRow
                className="flex"
                ref={viewRef}
                key={`${rowindex.toString()}_loaderrows`}
              >
                {Array.from({ length: columns?.length || 7 }).map(
                  (___, index: number) => (
                    <TableCell
                      key={`${index.toString()}_loadercolumn`}
                      className="last:!naxatw-pr-6 last:naxatw-text-right"
                    >
                      <Skeleton className=" naxatw-h-5 naxatw-w-14" />
                    </TableCell>
                  ),
                )}
              </TableRow>
            ))}
        </TableBody>
      </Table>
      {/* {showPagination && <DataTablePagination table={table} />} */}
    </FlexColumn>
  );
}
